import { ClientMode } from "@justhome/common/api/core";
import { useRouter } from "next/router";
import { FC } from "react";
import PartnerWithProperty from "./PartnerWithProperty";
import PartnerWithoutProperty from "./PartnerWithoutProperty";

interface PartnerProps {
  state: "pre" | "post";
  clientMode: ClientMode;
}

const Partner: FC<PartnerProps> = ({ state, clientMode }) => {
  const router = useRouter();

  if (!router.isReady) {
    return null;
  }

  if (router.query["property-id"]) {
    return <PartnerWithProperty state={state} clientMode={clientMode} />;
  }

  return <PartnerWithoutProperty clientMode={clientMode} />;
};

export default Partner;
